/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Delete_DescriptionInputs */



/**
* | output |
* | --- |
* | "This conversation will be permanently deleted. This action cannot be undone." |
*
* @param {Uno_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_delete_description = /** @type {((inputs?: Uno_Delete_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Delete_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Unterhaltung wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.")
	return /** @type {LocalizedString} */ ("This conversation will be permanently deleted. This action cannot be undone.")
});